export default __webpack_public_path__ + "static/media/open-doc.99bee6bc.svg";